var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rebalance-countdown"},[_c('countdown',{attrs:{"time":_vm.time,"transform":_vm.transformTimeSlotProps},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var totalDays = ref.totalDays;
var hours = ref.hours;
var minutes = ref.minutes;
var seconds = ref.seconds;
return [_c('span',{staticClass:"countdown-title"},[_vm._v(_vm._s(_vm.$t("stockPickingLab.nextRebalance"))+" ")]),(totalDays > 1)?_c('span',{staticClass:"daysOnly"},[_vm._v(" "+_vm._s((totalDays + " " + (_vm.$t("general.days"))))+" ")]):_c('span',{staticClass:"watch"},[_vm._v(" "+_vm._s(hours)+":"+_vm._s(minutes)+":"+_vm._s(seconds))])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }